exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ui.inverted.top.popup::before {\n  background: #4b8bb1 !important;\n}\n.pop-up--container {\n  background: #4b8bb1 !important;\n  color: #ffffff !important;\n  max-width: 460px !important;\n  padding: 1rem 1rem 1.5rem !important;\n}\n.ht-26 {\n  height: 26px !important;\n}\n.mt--5 {\n  margin-top: -5px !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/styles/components/editableLabel.less
// module id = 2630
// module chunks = 0